const getChartTitle = (
  dataset,
  selectedCountry,
  comparison,
  chartType,
  fuel
) => {
  if (comparison === "off") {
    return (
      selectedCountry + " " + dataset.longTitle.toLowerCase() + " by source"
    );
  } else {
    return (
      dataset.longTitle + (dataset.multipleSeries ? " - " + fuel.value : "")
    );
  }
};

const getChartSubtitle = (dataset, dataTreatment) => {
  if (dataTreatment === "absolute") {
    return dataset.units;
  } else {
    return "Percentage share";
  }
};

const getXAxisTitle = (dataset) => {
  if (dataset.temporalResolution === "yearly") {
    return "Year";
  } else if (dataset.temporalResolution === "monthly") {
    return "Date";
  }
};

const getDateType = (dataset) => {
  if (dataset.temporalResolution === "yearly") {
    return "";
  } else if (dataset.temporalResolution === "monthly") {
    return "datetime";
  }
};

export { getChartTitle, getChartSubtitle, getXAxisTitle, getDateType };
